import * as React from "react";

import { ChecklistRow } from "./Chapters";

export default ({ key, method, storeName }) => {
  switch (key) {
    default:
      return <ChecklistRow method={method} storeName={storeName} />;
  }
};
